export default __webpack_public_path__ + "static/media/germany.cf16b1b6.svg";